import { render, staticRenderFns } from "./WidgetsVehicleInfo.vue?vue&type=template&id=646347ba&scoped=true"
import script from "./WidgetsVehicleInfo.vue?vue&type=script&lang=js"
export * from "./WidgetsVehicleInfo.vue?vue&type=script&lang=js"
import style0 from "./WidgetsVehicleInfo.vue?vue&type=style&index=0&id=646347ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646347ba",
  null
  
)

export default component.exports